// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__Pjlcx","icon":"nav_icon__XBXgr","title":"nav_title__6LCby","title-active":"nav_title-active__pbJcD"};